import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "drag--drop"
    }}>{`Drag & drop`}</h1>
    <p>{`Chonky supports drag & drop (DnD) out-of-the-box. The relevant functionality is
implemented using `}<a parentName="p" {...{
        "href": "https://react-dnd.github.io/react-dnd/docs/overview"
      }}>{`react-dnd`}</a>{`.`}</p>
    <h2 {...{
      "id": "disabling-dnd"
    }}>{`Disabling DnD`}</h2>
    <p>{`If you want to disable DnD globally, you can use `}<inlineCode parentName="p">{`setChonkyDefaults`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { setChonkyDefaults } from 'chonky';

setChonkyDefaults({
    disableDragAndDrop: true,
});
`}</code></pre>
    <p>{`To disable DnD on a specific file browser, you can use the `}<inlineCode parentName="p">{`disableDragAndDrop`}</inlineCode>{` prop:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FileBrowser files={[]} disableDragAndDrop={true}>
    {/* ... */}
</FileBrowser>
`}</code></pre>
    <h2 {...{
      "id": "cannot-have-two-html5-backends"
    }}>{`"Cannot have two HTML5 backends"`}</h2>
    <p>{`For the majority of use cases, DnD will just work. However, if you want to use multiple
`}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` instances on the same page, you will start seeing this error:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`Error: Cannot have two HTML5 backends at the same time.
`}</code></pre>
    <p>{`This happens because of the way `}<inlineCode parentName="p">{`react-dnd`}</inlineCode>{` works. It requires a `}<inlineCode parentName="p">{`DndProvider`}</inlineCode>{` to be
present somewhere in the component tree, above the component that actually uses DnD
functionality. To support this, Chonky's internal component hierarchy looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tree"
      }}>{`- FileBrowser
    - DnDProvider
        - ChonkyDnD
`}</code></pre>
    <p>{`That said, `}<inlineCode parentName="p">{`react-dnd`}</inlineCode>{` also requires that only one `}<inlineCode parentName="p">{`DnDProvider`}</inlineCode>{` is mounted at a time,
so when you have multiple file browsers in your app you start hitting problems:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const MyApp = () => {
    return (
        <React.Fragment>
            <FileBrowser files={[]} />
            <FileBrowser files={[]} />
        </React.Fragment>
    );
};
`}</code></pre>
    <p>{`Resultant component hierarchy:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tree"
      }}>{`- MyApp
    - FileBrowser
        - DnDProvider
            - ChonkyDnD
    - FileBrowser
        - DnDProvider         <---- Duplicate provider!
            - ChonkyDnD
`}</code></pre>
    <p>{`The solution is quite simple:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { FileBrowser } from 'chonky';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const MyApp = () => {
    return (
        <DndProvider backend={HTML5Backend}>
            <FileBrowser files={[]} disableDragAndDropProvider={true} />
            <FileBrowser files={[]} disableDragAndDropProvider={true} />
        </DndProvider>
    );
};
`}</code></pre>
    <p>{`The code above does two things. First, it disables Chonky's internal `}<inlineCode parentName="p">{`DnDProvider`}</inlineCode>{` by
setting the `}<inlineCode parentName="p">{`disableDragAndDropProvider`}</inlineCode>{` prop on `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{` to `}<inlineCode parentName="p">{`true`}</inlineCode>{`. Second, it
adds a custom `}<inlineCode parentName="p">{`DnDProvider`}</inlineCode>{` at the top-level of the application.`}</p>
    <p>{`Note that you don't have to use `}<inlineCode parentName="p">{`HTML5Backend`}</inlineCode>{`, you can use any `}<inlineCode parentName="p">{`react-dnd`}</inlineCode>{`-compatible
backend that you want.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      